import { render, staticRenderFns } from "./StakingDesc.vue?vue&type=template&id=7fa98586&scoped=true"
import script from "./StakingDesc.vue?vue&type=script&lang=js"
export * from "./StakingDesc.vue?vue&type=script&lang=js"
import style0 from "./StakingDesc.vue?vue&type=style&index=0&id=7fa98586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa98586",
  null
  
)

export default component.exports